__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "lumahealth-webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.0", () => (Promise.all([__webpack_require__.e(1152), __webpack_require__.e(5835), __webpack_require__.e(3107)]).then(() => (() => (__webpack_require__(913107))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(5835), __webpack_require__.e(5996), __webpack_require__.e(2602)]).then(() => (() => (__webpack_require__(292602))))));
			register("@lumahealthhq/ui-context", "7.16.0", () => (Promise.all([__webpack_require__.e(3246), __webpack_require__.e(4354), __webpack_require__.e(6892)]).then(() => (() => (__webpack_require__(566892))))));
			register("@lumahealthhq/ui-context", "7.2.0", () => (Promise.all([__webpack_require__.e(3246), __webpack_require__.e(4354), __webpack_require__.e(6145)]).then(() => (() => (__webpack_require__(736145))))));
			register("@lumahealthhq/ui-context", "7.2.0", () => (Promise.all([__webpack_require__.e(3246), __webpack_require__.e(4354), __webpack_require__.e(5963)]).then(() => (() => (__webpack_require__(805963))))));
			register("@mui/icons-material", "5.15.13", () => (Promise.all([__webpack_require__.e(6090), __webpack_require__.e(9162), __webpack_require__.e(5835), __webpack_require__.e(5996), __webpack_require__.e(6224)]).then(() => (() => (__webpack_require__(469162))))));
			register("@mui/material", "5.13.1", () => (Promise.all([__webpack_require__.e(1152), __webpack_require__.e(6090), __webpack_require__.e(1005), __webpack_require__.e(4130), __webpack_require__.e(5835), __webpack_require__.e(5996), __webpack_require__.e(3419), __webpack_require__.e(6224)]).then(() => (() => (__webpack_require__(264130))))));
			register("moment-timezone", "0.5.48", () => (Promise.all([__webpack_require__.e(4280), __webpack_require__.e(1739)]).then(() => (() => (__webpack_require__(794280))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(3246).then(() => (() => (__webpack_require__(23246))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(5835)]).then(() => (() => (__webpack_require__(470914))))));
			register("react-hook-form", "7.48.2", () => (Promise.all([__webpack_require__.e(1132), __webpack_require__.e(5835)]).then(() => (() => (__webpack_require__(471132))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(3407), __webpack_require__.e(5835), __webpack_require__.e(3419), __webpack_require__.e(8955)]).then(() => (() => (__webpack_require__(133407))))));
			register("react-singleton-context", "1.0.4", () => (Promise.all([__webpack_require__.e(5835), __webpack_require__.e(4668)]).then(() => (() => (__webpack_require__(344668))))));
			register("react", "17.0.2", () => (__webpack_require__.e(9255).then(() => (() => (__webpack_require__(49255))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};